import store from '../../redux/store';
import { showCustomAlert } from "../../redux/alert/alert.action";

const axios = require('axios');
// const BASE_URL = "http://onstrips.com/onstripwebsite/OnstripIAMadmin/webservices/";
const BASE_URL = "https://apnaatravel.com/apnaatravelIAMadmin/webservices/";

// const BASE_URL = "http://139.59.76.223/onstripwebsite/OnstripIAMadmin/webservices/";

// OnstripIAMadmin
export const hitServerApi = async (urlMethod, data={}, method = "post") => {
    data.user_id = await get_session_user_id()
    const LOGIN_ENDPOINT = `${BASE_URL}${urlMethod}`;
    return new Promise(async (resolve, reject) => {
      await axios({
        method: method,
        url: LOGIN_ENDPOINT,
        // headers: {
        //   Authorization: get_session_token(),
        // },
        data: data,
        headers:{
          'Accept': 'application/json',
            'Content-Type': 'application/json',
        },

      })
        .then((response) => resolve(response.data))
        .catch((e) => {
          const errorobj = {
            status: false,
            message: e.message,
          };
          reject(errorobj);
        });
    });
};


export const fare_calculate_flight = async (fare={},airlinecode) => {
  // const usdata = store.getState();
  // console.log('fare_calculate_flight',usdata);
  return  0

}


export const get_flight_tokenId =async  (data={}) => {
  const serverdata = await hitServerApi("get_flight_tokenId", data);
  return serverdata;
};


export const get_all_airports =async  (data={}) => {
  const serverdata = await hitServerApi("fetch_airports", data);
  return serverdata;
};

export const search_flights_data = async (data={}) => {
  const serverdata =await  hitServerApi("search_flights", data);
  // debugger;
  return serverdata;
};

export const get_calendar_fare = async (data={}) => {
  const serverdata = await hitServerApi("get_calendar_fare", data);
  return serverdata;
};


export const get_fare_rule_resultindex = async (data={}) => {
  const serverdata = await hitServerApi("get_fare_rule_resultindex", data);
  return serverdata;
};



export const get_fare_quote_resultindex = async (data={}) => {
  const serverdata = await hitServerApi("get_fare_quote_resultindex", data);
  return serverdata;
};


export const add_member = async (data={}) => {
  const serverdata = await hitServerApi("add_member_new", data);
  return serverdata;
};


export const edit_member = async (data={}) => {
  const serverdata = await hitServerApi("edit_member", data);
  return serverdata;
};


export const delete_member = async (data={}) => {
  const serverdata = await hitServerApi("delete_member", data);
  return serverdata;
};

export const get_members = async (data={}) => {
  const serverdata = await hitServerApi("get_members", data);
  return serverdata;
};


export const get_airlines = async (data={}) => {
  const serverdata = await hitServerApi("get_airlines", data);
  return serverdata;
};




export const showAlertMessage = (title='alert',message='',success=false,danger=false) => {
  const alert_config =  {
      show_alert:true,
      title:title,
      message:message,
      success:success,
      danger:danger
  }
  store.dispatch(showCustomAlert(alert_config))
}

export const get_session_user_id = () => {
  const localstoraged = localStorage.getItem('user_id');
  if(localstoraged){
    return parseInt(localstoraged)
  }else{
    // return 64;
    return 71;
  }

}

// public function paytm_redirect()
// 	{

// 		$data['TXN_AMOUNT'] = $TXN_AMOUNT = $this->session->userdata('TXN_AMOUNT');
// 		$data['CUST_ID'] = $CUST_ID = $this->session->userdata('CUST_ID');
// 		$data['CALLBACK_URL'] = $CALLBACK_URL = base_url('welcome/online_txn');
// 		if(!empty($TXN_AMOUNT) && !empty($CUST_ID) && !empty($CALLBACK_URL)){
// 			$this->load->view('website/paytm_redirect',$data);
// 		}else{
// 			$this->session->set_flashdata('alert_message', array('message' =>'Something went wrong.', 'class' => 'error','subject'=>'Oops'));
// 			redirect(base_url());
// 		}

// 	}